import { render, staticRenderFns } from "./indexDetails.vue?vue&type=template&id=058b31e2&scoped=true&"
import script from "./indexDetails.vue?vue&type=script&lang=ts&"
export * from "./indexDetails.vue?vue&type=script&lang=ts&"
import style0 from "./indexDetails.vue?vue&type=style&index=0&id=058b31e2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "058b31e2",
  null
  
)

export default component.exports